import * as THREE from "three";
import type { Sponsors } from "../sponsors.ts";
import { sponsorWalls } from "./walls.ts";
import { onWall } from "./billboards.ts";
import { textPanel } from "./text-panel.ts";
import { createSprite } from "./sprite.ts";

const HEADER_Y = 4.7;
const LOGO_Y = 2.6;
const LOGO_H = 1.7;

// The two sponsor walls: a header per wall + a centred row of partner/supporter
// logos (from assets/sponsors.json). Shows a placeholder until logos are added.
export function createSponsors(data: Sponsors): THREE.Group {
  const group = new THREE.Group();
  group.name = "sponsors";

  sponsorWalls.forEach((slot, i) => {
    const g = data.groups[i];
    const title = g?.title?.trim() || "Aliados";
    const logos = g?.logos ?? [];

    group.add(
      onWall(textPanel({ title: `🤝 ${title}` }, 7, 1.5), slot, HEADER_Y),
    );

    if (logos.length === 0) {
      group.add(onWall(
        textPanel(
          {
            title: "Espacio disponible",
            body: "Aquí irán los logos de nuestros aliados y patrocinadores.",
            footer: "¿Quieres aparecer aquí?",
          },
          7,
          3,
        ),
        slot,
        LOGO_Y,
      ));
      return;
    }

    const spacing = Math.min(2.8, 8 / logos.length);
    logos.forEach((logo, k) => {
      const sprite = createSprite(logo.image, LOGO_H);
      sprite.mesh.position.x = (k - (logos.length - 1) / 2) * spacing;
      group.add(onWall(sprite.mesh, slot, LOGO_Y));
    });
  });

  return group;
}
